<template>
    <div class="ras-quiz">
        <label
            :class="[
                'ras-quiz-button',
                { 'ras-quiz-button--checked': checked == option }
            ]"
            v-for="(option, i) of options"
            :key="i"
        >
            <img v-if="option" :src="`images/svgs/${option}.svg`" />
            <span v-else></span>
            <span class="ras-heading ras-quiz-button__label" :for="option">{{
                option
            }}</span>
            <input
                :id="option"
                v-model="checked"
                type="radio"
                :value="option"
                @change="onChange"
            />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: false,
            default: () => []
        },
        selected: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: () => ({
        checked: ''
    }),
    methods: {
        onChange() {
            this.$emit('input', this.checked)
        }
    },
    watch: {
        selected(val) {
            this.checked = val
        }
    }
}
</script>

<style lang="scss">
.ras-radio {
}
</style>
